/** 4.26 Empty state: optional 96 px art, d-s title, small body saying why it is empty and what fills it, 200 × 48 primary. */
import type { ReactElement, ReactNode } from "react";
import { Button } from "./Button";
export interface EmptyStateProps { title: string; body: string; action?: { label: string; onClick?: () => void; to?: string; busy?: boolean }; art?: ReactNode; className?: string }
export function EmptyState({ title, body, action, art, className = "" }: EmptyStateProps): ReactElement {
  return (
    <div className={`empty ${className}`}>
      {art && <div className="empty__art">{art}</div>}
      <h2 className="empty__title">{title}</h2>
      <p className="empty__body">{body}</p>
      {action && <div className="empty__action"><Button kind="primary" size={48} to={action.to} onClick={action.onClick} busy={action.busy}>{action.label}</Button></div>}
    </div>
  );
}
